// src/redux/slices/auth.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedSiteId: null,
  selectedSiteTimezone: null,
  siteTemplates: null,
};

export const visitorLogsSlice = createSlice({
  name: 'loadVisitorLogs',
  initialState,
  reducers: {
    setSelectedSiteId(state, { payload }) {
      state.selectedSiteId = payload || null; // site id
    },
    setSelectedSiteTimezone(state, { payload }) {
      state.selectedSiteTimezone = payload || null; // site timezone
    },
    setSiteTemplates(state, { payload }) {
      state.siteTemplates = payload || null; // site templates
    },
  },
});

export const { setSelectedSiteId, setSelectedSiteTimezone, setSiteTemplates } =
  visitorLogsSlice.actions;

export default visitorLogsSlice.reducer;
